export enum EntityCreateType {
  MANUAL = 'MANUAL',
  AI = 'AI',
  AI_AGENT = 'AI_AGENT',
}
